module.exports = __webpack_public_path__ + "static/media/bikerGirlsSpain.8eb100b0.png";